import React from "react";
import { View, StyleSheet } from "react-native";
import Text from "@components/CustomText";
import DsModal from "./DsModal";
import { tokens } from "./tokens";

// Reusable bottom-sheet wrapper.
//
// Layout: header → body (whatever children pass; if they need scrolling
// they wrap in their own ScrollView) → optional `footer` slot which is
// **sticky** (renders below the body, never scrolls). The footer is where
// SheetButtons should live so the Save / Confirm action is always visible
// no matter how long the body's list is. DsModal keeps it above the soft
// nav buttons and the keyboard.

const BottomSheet = ({
  visible,
  title,
  subtitle,
  onClose,
  children,
  footer,
}) => {
  return (
    <DsModal
      visible={visible}
      onClose={onClose}
      scrim={tokens.modalScrim}
      contentStyle={styles.sheet}
    >
      <View style={styles.handle} />
      {title ? (
        <View style={styles.header}>
          <Text variant="title_16" style={styles.title}>
            {title}
          </Text>
          {subtitle ? (
            <Text variant="caption_2" style={styles.subtitle}>
              {subtitle}
            </Text>
          ) : null}
        </View>
      ) : null}
      <View style={styles.body}>{children}</View>
      {footer ? <View style={styles.footer}>{footer}</View> : null}
    </DsModal>
  );
};

export default BottomSheet;

const styles = StyleSheet.create({
  sheet: {
    backgroundColor: tokens.surface,
    borderTopLeftRadius: tokens.radius.xl,
    borderTopRightRadius: tokens.radius.xl,
    paddingBottom: tokens.spacing.large,
    minHeight: "50%",
    maxHeight: "85%",
  },
  handle: {
    alignSelf: "center",
    width: 40,
    height: 4,
    borderRadius: 2,
    backgroundColor: tokens.borderMedium,
    marginTop: tokens.spacing.small,
    marginBottom: tokens.spacing.small,
  },
  header: {
    paddingHorizontal: tokens.spacing.large,
    paddingBottom: tokens.spacing.medium,
    borderBottomWidth: StyleSheet.hairlineWidth,
    borderBottomColor: tokens.borderLight,
  },
  title: { color: tokens.textHeading, fontWeight: "700" },
  subtitle: {
    color: tokens.textSecondary,
    fontSize: 12,
    marginTop: 2,
  },
  body: {
    paddingHorizontal: tokens.spacing.large,
    paddingTop: tokens.spacing.medium,
    flexShrink: 1,
  },
  footer: {
    paddingHorizontal: tokens.spacing.large,
    paddingTop: tokens.spacing.medium,
    borderTopWidth: StyleSheet.hairlineWidth,
    borderTopColor: tokens.borderLight,
    backgroundColor: tokens.surface,
  },
});
